export default __webpack_public_path__ + "static/tn-feature-tile-shopping-plans-76d523eee47dad84db52aeb4383631d3.webp";